import type { StepDefinition } from "@/shared/components/common/PropertyStepperScreen";
import type { LocalSupportingDocumentItem } from "@/features/protest/services/localSupportingDocuments.service";
import { SupportingDocumentsReviewSection } from "../SupportingDocumentsReviewSection";

export type CommercialReviewStepPageProps = {
  commercialSteps: StepDefinition[];
  localSupportingDocuments: LocalSupportingDocumentItem[];
};

export const CommercialReviewStepPage = ({
  commercialSteps,
  localSupportingDocuments,
}: CommercialReviewStepPageProps) => {
  return (
    <SupportingDocumentsReviewSection
      steps={commercialSteps}
      localSupportingDocuments={localSupportingDocuments}
    />
  );
};
